import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
	CLUSTER_COMMUNITY_FEATURE_KEY,
	ClusterCommunityState,
	ClusterCommunityPartialState,
	clusterCommunityAdapter
} from './cluster-community.reducer';

// Lookup the 'ClusterCommunity' feature state managed by NgRx
export const getClusterCommunityState = createFeatureSelector<
	ClusterCommunityPartialState,
	ClusterCommunityState
>(CLUSTER_COMMUNITY_FEATURE_KEY);

const { selectAll, selectEntities } = clusterCommunityAdapter.getSelectors();

export const getClusterCommunityLoaded = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => state.loaded
);

export const getClusterCommunityError = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => state.error
);

export const loadingClusterCommunity = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => state.loaded
);

export const getAllClusterCommunity = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => selectAll(state)
);

export const getClusterCommunityEntities = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => selectEntities(state)
);

export const getSelectedId = createSelector(
	getClusterCommunityState,
	(state: ClusterCommunityState) => state.selectedClusterCommunityId
);

export const getSelected = createSelector(
	getClusterCommunityEntities,
	getSelectedId,
	(entities, selectedId) => selectedId && entities[selectedId]
);
